<template>
  <div class="upload-container">
    <!-- 选择上传方式 -->
    <div class="upload-options" v-if="!uploadMode">
      <div class="option-card" @click="selectUploadMode('url')">
        <div class="option-content">
          <i class="el-icon-link"></i>
          <span>通用网页替换</span>
        </div>
      </div>
      <div class="option-card" @click="selectUploadMode('file')">
        <div class="option-content">
          <i class="el-icon-document"></i>
          <span>客户文件替换</span>
        </div>
      </div>
            <!-- <div class="option-card" @click="selectUploadMode('yz')">
              <div class="option-content">
                <i class="el-icon-document"></i>
                <span>带登录校验的网页替换</span>
              </div>
            </div> -->
      <div class="option-card" @click="selectUploadMode('batch')">
        <div class="option-content">
          <i class="el-icon-picture"></i>
          <span>图片转链接</span>
        </div>
      </div>
    </div>

    <!-- URL上传模式 -->
    <div v-if="uploadMode === 'url'">
      <div class="url-upload-area">
        <el-input
          v-model="urlInput"
          placeholder="请输入页面URL"
          clearable
          style="width: 80%; margin-right: 10px;"
        ></el-input>
        <el-button
          type="primary"
          @click="downloadByUrl"
          :loading="downloading"
          :disabled="!urlInput || downloading"
        >
          {{ downloading ? '下载中...' : '提交' }}
        </el-button>
      </div>
      <el-button @click="resetMode" style="margin-top: 20px;">返回</el-button>
    </div>

    <!-- 文件上传模式 -->
    <div v-if="uploadMode === 'file'">
      <!-- 单文件上传区域 -->
      <div class="file-upload-section">
        <h3>上传HTML文件</h3>
        <div class="upload-demo" @dragover.prevent @drop.prevent="handleDrop">
          <div class="upload-area" @click="$refs.fileInput.click()">
            <i class="el-icon-upload"></i>
            <div class="text">
              <p>将文件拖到此处，或<span class="el-upload__text">点击上传</span></p>
              <p class="el-upload__tip">支持文件上传</p>
            </div>
            <input
              type="file"
              ref="fileInput"
              @change="handleFileSelect"
              style="display: none"
            />
          </div>
        </div>
      </div>

      <!-- 文件夹上传区域 -->
      <div class="folder-upload-section">
        <h3>上传静态资源文件</h3>
        <div class="folder-upload-area">
          <input
            type="file"
            ref="folderInput"
            webkitdirectory
            multiple
            @change="handleFolderSelect"
            style="display: none"
          />
          <el-button @click="$refs.folderInput.click()" type="primary">
            选择文件夹
          </el-button>
          <span class="el-upload__tip" style="margin-left: 10px;">
            选择整个文件夹进行上传
          </span>
        </div>
      </div>

      <!-- 文件列表显示 -->
      <div class="file-list-container" v-if="fileList.length > 0">
        <el-table :data="fileList" style="width: 100%" max-height="300">
          <el-table-column prop="name" label="文件名" width="250">
            <template slot-scope="scope">
              <i :class="getFileIcon(scope.row.raw.type, scope.row.relativePath)"></i>
              <span :title="getDisplayPath(scope.row)">
                {{ getDisplayPath(scope.row) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="size" label="大小" width="120">
            <template slot-scope="scope">
              {{ formatFileSize(scope.row.size) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button
                type="danger"
                size="mini"
                @click="handleRemove(scope.row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 上传操作按钮 -->
      <div class="upload-actions" style="margin-top: 20px; text-align: center;">
        <el-button
          type="primary"
          @click="uploadAllFiles"
          :disabled="fileList.length === 0 || uploading"
          :loading="uploading"
        >
          {{ uploading ? '上传中...' : '提交' }}
        </el-button>
        <el-button @click="clearFiles">清空列表</el-button>
        <el-button @click="resetMode" style="margin-left: 10px;">返回</el-button>
      </div>
    </div>

    <!-- 有赞上传模式 -->
    <div v-if="uploadMode === 'yz'">
      <!-- 单文件上传区域 -->
      <div class="file-upload-section">
        <h3>上传HTML文件</h3>
        <div class="upload-demo" @dragover.prevent @drop.prevent="handleDrop">
          <div class="upload-area" @click="$refs.fileInput.click()">
            <i class="el-icon-upload"></i>
            <div class="text">
              <p>将文件拖到此处，或<span class="el-upload__text">点击上传</span></p>
              <p class="el-upload__tip">支持文件上传</p>
            </div>
            <input
              type="file"
              ref="fileInput"
              @change="handleFileSelect"
              style="display: none"
            />
          </div>
        </div>
      </div>

      <!-- 文件列表显示 -->
      <div class="file-list-container" v-if="fileList.length > 0">
        <el-table :data="fileList" style="width: 100%" max-height="300">
          <el-table-column prop="name" label="文件名" width="250">
            <template slot-scope="scope">
              <i :class="getFileIcon(scope.row.raw.type, scope.row.relativePath)"></i>
              <span :title="getDisplayPath(scope.row)">
                {{ getDisplayPath(scope.row) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="size" label="大小" width="120">
            <template slot-scope="scope">
              {{ formatFileSize(scope.row.size) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button
                type="danger"
                size="mini"
                @click="handleRemove(scope.row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 上传操作按钮 -->
      <div class="upload-actions" style="margin-top: 20px; text-align: center;">
        <el-button
          type="primary"
          @click="uploadAllFiles1"
          :disabled="fileList.length === 0 || uploading"
          :loading="uploading"
        >
          {{ uploading ? '上传中...' : '提交' }}
        </el-button>
        <el-button @click="clearFiles">清空列表</el-button>
        <el-button @click="resetMode" style="margin-left: 10px;">返回</el-button>
      </div>
    </div>

    <!-- 批量图片上传模式 -->
    <div v-if="uploadMode === 'batch'">
      <div class="file-upload-section">
        <h3>批量上传图片</h3>
        <div class="upload-demo" @dragover.prevent @drop.prevent="handleBatchDrop">
          <div class="upload-area" @click="$refs.batchInput.click()">
            <i class="el-icon-upload"></i>
            <div class="text">
              <p>将图片拖到此处，或<span class="el-upload__text">点击上传</span></p>
              <p class="el-upload__tip">支持多张图片上传</p>
            </div>
            <input
              type="file"
              ref="batchInput"
              @change="handleBatchSelect"
              style="display: none"
              multiple
              accept="image/*"
            />
          </div>
        </div>
      </div>

      <!-- 图片列表显示 -->
      <div class="file-list-container" v-if="batchFileList.length > 0">
        <el-table :data="batchFileList" style="width: 100%" max-height="300">
          <el-table-column prop="name" label="文件名" min-width="250">
            <template slot-scope="scope">
              <i class="el-icon-picture"></i>
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="文件预览图" min-width="120">
            <template slot-scope="scope">
              <img :src="scope.row.previewUrl" style="width:60px;height:60px;object-fit:cover;border-radius:4px;" />
            </template>
          </el-table-column>
          <el-table-column prop="size" label="大小" min-width="120">
            <template slot-scope="scope">
              {{ formatFileSize(scope.row.size) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="150">
            <template slot-scope="scope">
              <el-button
                type="danger"
                size="mini"
                @click="handleBatchRemove(scope.row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="链接">
            <template slot-scope="scope">
              <template v-if="scope.row.uploadedUrl">
                <el-button type="primary" size="mini" @click="copyUrl(scope.row.uploadedUrl)">复制</el-button>
              </template>
              <template v-else>
                <span></span>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 上传操作按钮 -->
      <div class="upload-actions" style="margin-top: 20px; text-align: center;">
        <el-button
          type="primary"
          @click="uploadBatchImages"
          :disabled="batchFileList.length === 0 || uploading"
          :loading="uploading"
        >
          {{ uploading ? '上传中...' : '提交' }}
        </el-button>
        <el-button @click="clearBatchFiles">清空列表</el-button>
        <el-button @click="resetMode" style="margin-left: 10px;">返回</el-button>
      </div>

      
    </div>

    <!-- 加载弹窗 -->
    <el-dialog
      :visible.sync="loading"
      title="请等待"
      width="300px"
      center
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div style="text-align: center;">
        <i class="el-icon-loading" style="font-size: 24px; margin-bottom: 10px;"></i>
        <p>正在处理，请稍候，预计需要两分钟...</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { post } from '../until/controlRequest'
import axios from "axios";

export default {
  name: 'ImgToUrl',
  data() {
    return {
      uploadMode: '',
      urlInput: '',
      fileList: [],
      batchFileList: [],
      uploadedUrls: [],
      uploading: false,
      downloading: false,
      loading: false,
    }
  },
  methods: {
    // 选择上传模式
    selectUploadMode(mode) {
      this.uploadMode = mode;
    },

    // 重置模式选择
    resetMode() {
      this.uploadMode = '';
      this.urlInput = '';
      this.fileList = [];
      this.batchFileList = [];
      this.uploadedUrls = [];
      this.uploading = false;
      this.downloading = false;

      // 清空input值
      if (this.$refs.fileInput) this.$refs.fileInput.value = '';
      if (this.$refs.folderInput) this.$refs.folderInput.value = '';
      if (this.$refs.batchInput) this.$refs.batchInput.value = '';
    },

    // 通过URL下载
    async downloadByUrl() {
      if (!this.urlInput) {
        this.$message.warning('请输入URL');
        return;
      }

      this.downloading = true;
      this.loading = true;
      try {
        const formData = new FormData();
        formData.append('url', this.urlInput);

        // 使用axios直接调用API
        const response = await axios.post('https://control.zjwec.cn/api/v1/img/urlChange', formData, {
        // const response = await axios.post('http://localhost:9998/api/v1/img/urlChange', formData, {
          responseType: 'blob',
          timeout: 200000
        });
        this.downloadFile(response);
      } catch (error) {
        this.$message.error('该网页内容无法获取，请尝试文件上传的形式处理！');
      } finally {
        this.downloading = false;
        this.loading = false;
      }
    },

    // 处理文件选择
    handleFileSelect(event) {
      const files = Array.from(event.target.files)
      this.addFilesToList(files)
      // 清空input值，以便可以重复选择相同文件
      event.target.value = ''
    },

    // 处理拖拽上传
    handleDrop(event) {
      const files = Array.from(event.dataTransfer.files)
      this.addFilesToList(files)
    },

    // 处理文件夹选择
    handleFolderSelect(event) {
      const files = Array.from(event.target.files)
      this.addFilesToList(files)
    },

    // 将文件添加到文件列表
    addFilesToList(files) {
      const newFiles = files.map(file => {
        return {
          uid: `${Date.now()}_${Math.floor(Math.random() * 10000)}`,
          name: file.name,
          size: file.size,
          type: file.type,
          raw: file,
          status: 'ready',
          progress: 0,
          uploading: false,
          relativePath: file.webkitRelativePath || file.name
        }
      })

      this.fileList = [...this.fileList, ...newFiles]
    },

    // 处理文件移除
    handleRemove(file) {
      this.fileList = this.fileList.filter(item => item.uid !== file.uid)
    },

    // 获取显示路径
    // getDisplayPath(fileItem) {
    //   if (fileItem.relativePath && fileItem.relativePath.includes('/')) {
    //     const pathParts = fileItem.relativePath.split('/');
    //     return pathParts[0];
    //   }
    //   return fileItem.relativePath || fileItem.name;
    // },
    getDisplayPath(fileItem) {
      return fileItem.relativePath || fileItem.name;
    },

    // 获取文件图标
    getFileIcon(type, relativePath) {
      if (relativePath && relativePath.includes('/')) {
        return 'el-icon-folder';
      }
      if (type && type.startsWith('image/')) {
        return 'el-icon-picture';
      } else if (type && type.startsWith('text/')) {
        return 'el-icon-document';
      } else {
        return 'el-icon-files';
      }
    },

    // 格式化文件大小
    formatFileSize(size) {
      if (size === undefined || size === null) return '0 B'
      if (size === 0) return '0 B'
      if (size < 1024) {
        return size + ' B'
      } else if (size < 1024 * 1024) {
        return (size / 1024).toFixed(2) + ' KB'
      } else {
        return (size / (1024 * 1024)).toFixed(2) + ' MB'
      }
    },

    // 上传所有文件
    async uploadAllFiles() {
      if (this.fileList.length === 0) {
        this.$message.warning('请选择文件');
        return;
      }

      this.uploading = true;
      this.loading = true;
      try {
        const formData = new FormData();

        // 将所有文件添加到FormData中
        this.fileList.forEach(fileItem => {
          if (fileItem.status === 'ready') {
            formData.append('files', fileItem.raw);
          }
        });
        // 调用上传接口
        const response = await post('/v1/img/upload', formData, {
          responseType: 'blob',
          timeout: 200000
        });
        // 下载文件
        this.downloadFile(response);
        this.$message.success('上传完成');
        // 清空文件列表
        this.fileList = [];
      } catch (error) {
        this.$message.error('上传失败: ' + (error.message || '未知错误'));
      } finally {
        this.uploading = false;
        this.loading = false;
      }
    },

    async uploadAllFiles1() {
      if (this.fileList.length === 0) {
        this.$message.warning('请选择文件');
        return;
      }

      this.uploading = true;
      this.loading = true;
      try {
        const formData = new FormData();

        // 将所有文件添加到FormData中
        this.fileList.forEach(fileItem => {
          if (fileItem.status === 'ready') {
            formData.append('file', fileItem.raw);
          }
        });
        // 调用上传接口
        const response = await post('/v1/img/fileChange', formData, {
          responseType: 'blob',
          timeout: 200000
        });
        // 下载文件
        this.downloadFile(response);
        this.$message.success('上传完成');
        // 清空文件列表
        this.fileList = [];
      } catch (error) {
        this.$message.error('上传失败: ' + (error.message || '未知错误'));
      } finally {
        this.uploading = false;
        this.loading = false;
      }
    },

    downloadFile(response) {
      // 获取响应头中的文件名
      const contentDisposition = response.headers['content-disposition'];
      let filename = 'index.zip';
      if (contentDisposition) {
        // 提取文件名
        const filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1];
        }
      }
      // 创建一个下载链接
      const link = document.createElement('a');
      link.href = URL.createObjectURL(response.data);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    // 清空文件列表
    clearFiles() {
      this.fileList = [];
      if (this.$refs.fileInput) this.$refs.fileInput.value = '';
      if (this.$refs.folderInput) this.$refs.folderInput.value = '';
    },

    // 处理批量图片选择
    handleBatchSelect(event) {
      const files = Array.from(event.target.files)
      this.addBatchFilesToList(files)
      event.target.value = ''
    },

    // 处理批量图片拖拽上传
    handleBatchDrop(event) {
      const files = Array.from(event.dataTransfer.files)
      this.addBatchFilesToList(files)
    },

    // 将批量文件添加到列表
    addBatchFilesToList(files) {
      const newFiles = files
        .filter(file => file.type.startsWith('image/'))
        .map(file => {
          return {
            uid: `${Date.now()}_${Math.floor(Math.random() * 10000)}`,
            name: file.name,
            size: file.size,
            type: file.type,
            raw: file,
            status: 'ready',
            previewUrl: URL.createObjectURL(file),
            uploadedUrl: ''
          }
        })

      this.batchFileList = [...this.batchFileList, ...newFiles]
    },

    // 处理批量文件移除
    handleBatchRemove(file) {
      if (file && file.previewUrl) {
        URL.revokeObjectURL(file.previewUrl)
      }
      this.batchFileList = this.batchFileList.filter(item => item.uid !== file.uid)
    },

    // 批量上传图片
    async uploadBatchImages() {
      if (this.batchFileList.length === 0) {
        this.$message.warning('请选择图片文件');
        return;
      }

      this.uploading = true;
      this.loading = true;
      try {
        const formData = new FormData();
        this.batchFileList.forEach(fileItem => {
          if (fileItem.status === 'ready') {
            formData.append('files', fileItem.raw);
          }
        });

        const response = await post('/v1/img/batchUpload', formData, { timeout: 200000 });
        if (response) {
          const urls = Array.isArray(response) ? response.map(u => {
            if (typeof u === 'string') return u
            if (u && typeof u === 'object') {
              return u.url || u.link || u.href || ''
            }
            return ''
          }) : []
          this.uploadedUrls = urls
          this.batchFileList.forEach((fileItem, index) => {
            fileItem.uploadedUrl = urls[index] || ''
          })
          await this.copyUrlsToClipboard(urls)
          this.$message.success('图片链接已复制到剪贴板')
        } else {
          this.$message.error('上传失败或返回数据格式不正确');
        }
      } catch (error) {
        this.$message.error('上传失败: ' + (error.response ? error.response.data.message : error.message || '未知错误'));
      } finally {
        this.uploading = false;
        this.loading = false;
      }
    },

    async copyUrlsToClipboard(urls) {
      if (!urls || urls.length === 0) return;

      // 将 URL 数组转换为换行分隔的字符串
      const text = urls.join('\n');

      // 创建临时 textarea 元素用于复制
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);

      try {
        // 选中并复制内容
        textarea.select();
        await navigator.clipboard.writeText(text);
      } catch (err) {
        // 兼容性处理：使用 execCommand（旧浏览器）
        document.execCommand('copy');
      }

      document.body.removeChild(textarea);
    },


    // 清空批量文件列表
    clearBatchFiles() {
      this.batchFileList.forEach(f => {
        if (f.previewUrl) URL.revokeObjectURL(f.previewUrl)
      })
      this.batchFileList = [];
      this.uploadedUrls = [];
      if (this.$refs.batchInput) this.$refs.batchInput.value = '';
    },

    // 复制URL到剪贴板
    copyUrl(url) {
      const textarea = document.createElement('textarea');
      textarea.value = url;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      this.$message.success('链接已复制到剪贴板');
    },

    // 赋值URL到剪贴板并发送后端请求
    async assignUrl(url) {
      try {
        // 复制到剪贴板
        await navigator.clipboard.writeText(url);
        this.$message.success('链接已赋值到剪贴板');

        // 发送后端请求记录赋值操作
        await post('/v1/img/assignUrl', { url: url });
        this.$message.success('赋值操作已完成并记录到后台');
      } catch (error) {
        console.error('赋值操作失败:', error);
        this.$message.error('赋值操作失败');
      }
    }
  }
}
</script>

<style scoped>
.upload-container {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}

.upload-options {
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-top: 50px;
}

.option-card {
  width: 150px;
  height: 150px;
  border: 2px dashed #d9d9d9;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
}

.option-card:hover {
  border-color: #409eff;
  background-color: #f5f7fa;
}

.option-content {
  text-align: center;
}

.option-content i {
  font-size: 36px;
  color: #409eff;
  display: block;
  margin-bottom: 10px;
}

.option-content span {
  font-size: 18px;
  color: #606266;
}

.url-upload-area {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}

.file-upload-section,
.folder-upload-section {
  margin: 30px 0;
}

.file-upload-section h3,
.folder-upload-section h3 {
  text-align: center;
  margin-bottom: 15px;
}

.upload-demo {
  border: 2px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  padding: 20px;
  text-align: center;
  transition: border-color 0.3s;
}

.upload-demo:hover {
  border-color: #409eff;
}

.upload-area {
  padding: 20px;
}

.el-upload__tip {
  font-size: 12px;
  color: #909399;
  margin-top: 7px;
}

.file-list-container {
  margin-top: 20px;
}

.upload-actions .el-button {
  margin: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/imgtourl.vue